import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import TextAreaControl from '../Common/TextAreaControl';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import {isNullEmptyOrWhitespace} from "../../constants";
import {Link} from 'react-router-dom';
import { mustBeArray } from '../../utils/lib';
import _ from 'lodash-es';

class NotesView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      notes: props.notes ? props.notes : [],
      selectedNote: null,
    };

    this.handleSaveNote = this.handleSaveNote.bind(this);
    this.handleCancelNote = this.handleCancelNote.bind(this);
    this.handleNewNote = this.handleNewNote.bind(this);
    this.handleNoteFieldChange = this.handleNoteFieldChange.bind(this);
    this.validateNote = this.validateNote.bind(this);
    this.handleNoteDelete = this.handleNoteDelete.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }


  handleNoteFieldChange(e) {
    let x = {...this.state.selectedNote};
    x[`${e.target.name}`] = e.target.value;
    this.setState({selectedNote: x});
  }

  handleSaveNote() {
    let added = false;
    let notes = [...this.state.notes].map(x => {
      let returnVal = x;
      if (returnVal.id == this.state.selectedNote.id) {
        added = true;
        return this.state.selectedNote;
      }
      return returnVal;
    });
    if (!added) {
      notes = [...this.state.notes, this.state.selectedNote];
    }
    if(this.props.onChange){
      this.props.onChange(notes);
    }
    this.setState({ notes, selectedNote: null});
  }

  validateNote() {
    let {selectedNote} = this.state;
    if (this.state.selectedNote) {
      if (selectedNote.noteText.trim() == '') {
        return {valid: false, error: ''};
      }
    }
    return {valid: true, error: ''};
  }

  handleCancelNote() {
    this.setState({selectedNote: null});
  }

  handleNewNote() {
    let count = this.state.notes.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    this.setState({selectedNote: {id: (-1 - count), noteText: ''}});
  }

  handleNoteDelete(c) {
    let notes = this.state.notes.filter(x => x.id != c.id);
    if(this.props.onChange){
      this.props.onChange(notes);
    }
    this.setState({notes});
  }

  getColumns() {
    const {isLocationView, runNotes} = this.props;
    return [
      {
        accessor: 'noteText',
        Header: 'Note',        
      }, 
      {
        id: 'createdDate',
        Header: 'Created',
        accessor: c => c.id > 0 ? moment(c.updatedDate ? c.updatedDate : c.createdDate).format("DD/MM/YYYY h:mm:ss a") : '',
        maxWidth: 175,
        sortMethod: (a, b) => {
          return moment(a, "DD/MM/YYYY h:mm:ss a").isAfter(moment(b, "DD/MM/YYYY h:mm:ss a")) || isNullEmptyOrWhitespace(a) ? 1 : -1;
        },
      },
      {
        id: 'updatedBy',
        Header: 'Created By',
        accessor: c => {
          if(!isLocationView || _.isEmpty(mustBeArray(runNotes))) return c.updatedBy;
          const runNote = _.find(mustBeArray(runNotes), o => o.id === c.id);
          return runNote ? 
            <Link to={`/runs/search/${runNote.runId}`} style={{padding: 0}} className='nav-link'>{`Driver notes from RUNID: ${runNote.runId}`}</Link> 
            : c.updatedBy;},
      }
    ];
  }

  render() {
    const isValidNote = this.validateNote();
    let {notes, selectedNote} = this.state;

    return (this.props.visible || this.props.visible == undefined) ? (
      <div style={{marginBottom: '20px'}}>
        <div className="form-group row">
          <div className={"col-12"}>
            <h6>
              {this.props.headerText ? this.props.headerText : 'Notes'}&nbsp;<Button color="success" onClick={this.handleNewNote}><i className="fa fa-plus"/>&nbsp;&nbsp;Add
              note</Button>
            </h6>
          </div>
        </div>
        <div className="form-group row">
          <div className="col-12 col-md-12 col-xl-12">
            {selectedNote ?
              (<div className="form-horizontal">

                <TextAreaControl
                  name={'noteText'}
                  value={this.state.selectedNote.noteText}
                  onChange={this.handleNoteFieldChange}
                  labelText={'Note'}
                />

                <div className="form-group row">
                  <div className="offset-md-2 col-md-8">
                    {isValidNote.valid ?
                      <Button color="primary" onClick={this.handleSaveNote} style={{marginRight: '10px'}}><i
                        className="fa fa-check"/>&nbsp;
                      </Button> :
                      <span className="text-danger">{isValidNote.error}</span>
                    }
                    <Button color="seconday" onClick={this.handleCancelNote}><i className="fa fa-mail-reply"/>&nbsp;
                    </Button>
                  </div>
                </div>
              </div>)
              :
              (<ReactTable
                  sortable={true}
                  filterable={false}
                  showPagination={true}
                  data={notes}
                  columns={this.getColumns()}
                  minRows={5}
                  defaultPageSize={5}
                  defaultSorted={[{id: 'createdDate', desc: true}]}
              />)}


            
          </div>
        </div>
      </div>
    ) : null;
  }
}

NotesView.propTypes = {
  notes: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  headerText: PropTypes.string,
  visible: PropTypes.bool,
};

NotesView.defatultProps = {
  notes: [],
  headerText: 'Notes',
};

export default NotesView;